import {
    RAW_DATA_GET_DEVICE_READING_OPEN_MODAL,
    RAW_DATA_GET_DEVICE_READING_REQUEST,
    RAW_DATA_GET_DEVICE_READING_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    filters: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case RAW_DATA_GET_DEVICE_READING_OPEN_MODAL:
            return { ...state, openModal: action?.payload?.open, filters: action?.payload?.filters }

        case RAW_DATA_GET_DEVICE_READING_REQUEST:
            return { ...state, loading: true }

        case RAW_DATA_GET_DEVICE_READING_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "RAW_DATA_DEVICE_READING_INFO"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};